export function getDateFormatYMD2(date: Date) {
  return `${[
    date.getFullYear(),
    (date.getMonth() + 1).toString().padStart(2, "0"),
    date.getDate().toString().padStart(2, "0"),
  ].join("-")}`;
}
